// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"db64edd9","88":"35c7925f","146":"79498c51","203":"211762c8","264":"3dbec1af","292":"9894138d","355":"5bcc1836","488":"0c3d5910","530":"06588cf4","911":"8ec73ed7"}[chunkId] + ".chunk.js";
};